$(function(){
	var maskTel = "999-999-9999";
	var maskDate= "99.99.9999";
	var tels = $("input[name*=phone]");
	var dates= $("input[name*=date]");

	if(tels.length  > 0) tels.mask(maskTel);
	if(dates.length > 0) dates.mask(maskDate);


	var $licenseExpDateInput = $("input[name='license_exp_date']");
	if ($licenseExpDateInput.length) {
		$licenseExpDateInput.mask('99/99/9999');
	}
});
